import { ActivatedRoute } from '@angular/router';

const getFirstChild = (route: ActivatedRoute): ActivatedRoute | null => {
  while (route.firstChild) {
    route = route.firstChild;
  }
  return route;
};

export { getFirstChild };
